<template>
  <div class="wrapper mainbg">
    <!-- <reg-banner></reg-banner> -->
    <img :src="websiteBanner" width="100%" />
    <div class="reg-content clearfix">
      <list-loadding :showloadding="showloadding">
        <div class="reg-content-top">
          <div class="reg-card" v-for="(item, index) in list" :key="index">
            <div class="header">{{ item.coll.Surname }}</div>
            <div class="ticket">
              <div
                class="ticket-cell"
                :class="{ after: item.tickets.length != ii + 1 }"
                v-for="(tt, ii) in item.tickets"
                :key="ii"
              >
                <div class="ticket-top">
                  <div class="ticket-top-left">
                    <div class="icon" :class="tt.bg"></div>
                    <div class="txt">{{ tt.name }}</div>
                  </div>
                  <div class="ticket-top-right">
                    <div
                      class="state nopaid"
                      @click="gocard(item)"
                      v-if="tt.state == 'NOPAID'"
                    >
                      {{ tt.StateTxt }}
                    </div>
                    <div class="state" v-else>{{ tt.StateTxt }}</div>
                    <div class="ticket-icon">
                      <van-icon
                        v-show="tt.showContent"
                        @click="iconclick(item, tt)"
                        name="arrow-up"
                      />
                      <van-icon
                        v-show="!tt.showContent"
                        @click="iconclick(item, tt)"
                        name="arrow-down"
                      />
                    </div>
                  </div>
                </div>
                <div class="ticket-content" v-show="tt.showContent">
                  <div v-if="tt.id != 'T11'">
                    <div class="ticket-date" v-html="'时间：' + tt.datet"></div>
                    <div class="ticket-txt" v-show="tt.address">
                      <div>地点：</div>
                      <div class="txt" v-html="tt.address"></div>
                    </div>
                    <div class="ticket-txt">
                      <div>权益：</div>
                      <div class="txt" v-html="tt.des"></div>
                    </div>
                  </div>
                  <div v-else>
                    <div class="ticket-txt">
                      <div>酒店：</div>
                      <div class="txt" v-html="tt.hotelinfo.hname"></div>
                    </div>
                    <div class="ticket-txt">
                      <div>房型：</div>
                      <div class="txt" v-html="tt.hotelinfo.roomtype"></div>
                    </div>
                    <div class="ticket-txt">
                      <div>入住日期：</div>
                      <div class="txt" v-html="tt.hotelinfo.indate"></div>
                    </div>
                    <div class="ticket-txt">
                      <div>退房日期：</div>
                      <div class="txt" v-html="tt.hotelinfo.outdate"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </list-loadding>
    </div>
    <div class="reg-btn" v-if="!showloadding">
      <!-- <van-button type="primary" color="#009E38" round @click="goticket"
        >继续买票</van-button
      > -->
      <van-button type="primary" color="#009E38" round @click="goapply"
        >申请发票</van-button
      >
      <van-button color="#023A7C" round @click="goagenda">返回首页</van-button>
    </div>
    <div>
      <van-dialog
        v-model="fpshow"
        title="申请发票"
        confirmButtonText="提交"
        :beforeClose="chargeBtn"
        show-cancel-button
      >
        <div class="pf-list">
          <van-form ref="invoiceForm" @submit="onSubmit">
            <van-field
              v-model="fpmodel.company"
              name="company"
              label="发票抬头"
              placeholder="发票抬头"
              :rules="[{ required: true, message: '请输入发票抬头' }]"
            />
            <van-field
              v-model="fpmodel.taxno"
              name="taxno"
              label="税号"
              placeholder="税号"
              :rules="[{ required: true, message: '请输入税号' }]"
            />
            <van-field
              v-model="fpmodel.email"
              name="email"
              label="邮箱"
              placeholder="邮箱"
              :rules="[{ required: true, message: '请输入邮箱' }]"
            />
            <van-field
              name="ticketids"
              :rules="[{ required: true, message: '请选择票型' }]"
            >
              <template #input>
                <van-checkbox-group v-model="fpmodel.ticketids">
                  <van-checkbox
                    icon-size="16px"
                    v-for="(item, index) in fplist"
                    :key="index"
                    :name="item.id"
                    >{{ item.name }}</van-checkbox
                  >
                </van-checkbox-group>
              </template>
            </van-field>
          </van-form>
        </div>
      </van-dialog>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { GetTicketList, GetConfirmList, ApplyInvoice } from "@/api/ticket";
import {
  button,
  Cell,
  CellGroup,
  Dialog,
  Checkbox,
  CheckboxGroup,
  Form,
  field,
  Toast,
} from "vant";
import listLoadding from "@/components/listLoadding";
import { TBCActions } from "@/data/config";

export default {
  data() {
    return {
      list: [],
      pkey: "",
      showloadding: false,
      showContent: false,
      selectTicket: "",
      selectItem: "",
      fpshow: false,
      fplist: [],
      fpmodel: {
        company: "",
        taxno: "",
        amount: "",
        email: "",
        ticketids: [],
      },
    };
  },
  computed: {
    ...mapGetters(["websiteBanner", "userinfo"]),
  },
  components: {
    [Form.name]: Form,
    [field.name]: field,
    [button.name]: button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Dialog.Component.name]: Dialog.Component,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    listLoadding,
  },
  created() {
    document.title = "亚洲宠物展";
    console.log(this.$route.query);
    this.pkey = this.$route.query.pkey;
    console.log(this.userinfo);
    if (!this.$route.query.pkey) {
      this.pkey = this.userinfo.FullCardNumber;
    }
    this.getTickets();
  },
  methods: {
    chargeBtn(action, done) {
      let _this = this;
      if (action === "cancel") {
        done();
      } else if (action === "confirm") {
        done(false);
        _this.$refs.invoiceForm.submit();
      }
    },
    iconclick(item, itt) {
      this.selectItem = item;
      this.selectTicket = itt;
      this.list.map((t) => {
        if (t.coll.FullCardNumber == item.coll.FullCardNumber) {
          item.tickets.map((tt) => {
            if (tt.id == itt.id) {
              tt.showContent = !tt.showContent;
            }
          });
        }
      });
    },
    async getTickets() {
      var params = {
        pkey: this.pkey,
      };
      let _this = this;
      if (await this.$checkTicketLogin()) {
        _this.showloadding = true;
        GetConfirmList(params)
          .then((res) => {
            _this.showloadding = false;
            console.log(res);
            if (res.state == "success") {
              if (res.data) {
                // console.log(TBCActions);
                res.data.map((item) => {
                  if (item.tickets) {
                    item.tickets.map((e) => {
                      e["bg"] = "bg" + e.id;
                      if (e.state) {
                        e["StateTxt"] = TBCActions.get(e.state);
                      }
                      e["showContent"] = false;
                    });
                  }
                });
                _this.list = res.data;
                if (res.data && res.data[0].coll) {
                  _this.fpmodel.email = res.data[0].coll.Email;
                }
                if (res.data && res.data[0].invoices) {
                  _this.fplist = res.data[0].invoices;
                }
                console.log(_this.fpmodel);
                console.log(_this.list);
              }
            } else {
              console.log(res.msg);
            }
          })
          .catch((err) => {
            _this.showloadding = false;
            console.log(err);
          });
      }
    },
    goapply() {
      // console.log(this.list);
      // let filtlist = this.list[0].tickets.filter((item) => {
      //   return (
      //     item.state == "Complete" &&
      //     item.id == "T01" || item.id == "T02"
      //   );
      // });
      if (this.fplist && this.fplist.length > 0) {
        this.fpshow = true;
      } else {
        Toast("没有可开的发票");
      }
      console.log("fplist", this.fplist);
    },
    goticket() {
      this.$router.push({
        path: "ticket",
      });
    },
    goagenda() {
      // Toast("敬请期待");
      this.$router.push({
        name: "home",
      });
    },
    gocard(item) {
      console.log(item);
      this.$router.push({
        path: "payment",
        query: { ckey: item.coll.FullCardNumber },
      });
    },
    onSubmit(values) {
      console.log("submit", values);
      let _this = this;
      let params = {
        pkey: this.pkey,
        ...values,
      };
      ApplyInvoice(params)
        .then((res) => {
          console.log(res);
          if (res.state == "success") {
            Toast("开票成功。");
            _this.fpshow = false;
          } else {
            res.msg && Toast(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
      // console.log(this.fpmodel);
      // console.log(this.fpcheckboxgroup);
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .van-checkbox__icon--checked .van-icon {
  background-color: $theme-color;
  border-color: $theme-color;
}
.pf-list {
  font-size: 14px;
  padding: 5px 10px;
  .van-checkbox-group {
    .van-checkbox {
      margin: 10px;
    }
  }
}
.reg-content {
  min-height: 300px;
  // margin-top: -40px;
}
.ticket {
  //   min-height: 300px;
}
.ticket-empty {
  min-height: 400px;
  display: flex;
  text-align: center;
  margin-top: 50px;
  justify-content: center;
  align-items: center;
}
.reg-btn {
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: space-around;
  button {
    // margin-right: 20px;
    width: 150px;
  }
}
.ticket-cell {
  padding: 10px 16px;
  .ticket-top {
    display: flex;
    justify-content: space-between;
    .ticket-top-left {
      display: flex;
      align-items: center;
      .icon {
        height: 10px;
        width: 10px;
        border-radius: 50%;
        flex-shrink: 0;
      }
      .txt {
        margin-left: 5px;
        font-size: 14px;
        font-weight: bold;
      }
    }
    .ticket-top-right {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      .state {
        font-size: 13px;
        color: #999;
        margin-right: 5px;
        padding: 4px 8px;
        &.nopaid {
          border: 1px solid $theme-color;
          color: $theme-color;
        }
      }
      .ticket-icon {
        color: #999;
        .van-icon {
          font-size: 13px;
        }
      }
    }
  }
  .ticket-content {
    padding: 5px 15px;
    font-size: 13px;
    line-height: 21px;
    color: #999;
    .ticket-date {
      white-space: pre-line;
    }
    .ticket-txt {
      white-space: pre-line;
      display: flex;
      .txt {
        white-space: pre-line;
      }
    }
  }
}
.reg-card {
  margin-bottom: 20px;
  background: #fff;
  .header {
    background: $theme-color;
    color: #fff;
    border-radius: 12px 12px 0px 0px;
  }
}
</style>